// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormMetricModal-module__dsAccented--ibQyD,.FormMetricModal-module__dsAccented--ibQyD *{font-weight:500}.FormMetricModal-module__dsDefaultWeight--SGAxN,.FormMetricModal-module__dsDefaultWeight--SGAxN *{font-weight:400}h5.FormMetricModal-module__dsAccented--ibQyD,h5.FormMetricModal-module__dsAccented--ibQyD *{font-weight:700}.FormMetricModal-module__dsUnderline--U0jHe,.FormMetricModal-module__dsUnderline--U0jHe *{text-decoration:underline}.FormMetricModal-module__dsAccented2--rTOei,.FormMetricModal-module__dsAccented2--rTOei *{font-weight:700}.FormMetricModal-module__dsBodyXL--jofJk,.FormMetricModal-module__dsBodyXL--jofJk *{font-size:18px;line-height:27px}.FormMetricModal-module__dsBodyLarge--r3ZzZ,.FormMetricModal-module__dsBodyLarge--r3ZzZ *{font-size:16px;line-height:24px}.FormMetricModal-module__dsBody--dK2TO,.FormMetricModal-module__dsBody--dK2TO *{font-size:14px;line-height:20px}.FormMetricModal-module__dsBodySmall--z9OVT,.FormMetricModal-module__dsBodySmall--z9OVT *{font-size:12px;line-height:18px}.FormMetricModal-module__dsBodyXS--LrzZn,.FormMetricModal-module__dsBodyXS--LrzZn *{font-size:10px;line-height:15px}.FormMetricModal-module__dsActionLarge--rBj4A,.FormMetricModal-module__dsActionLarge--rBj4A *{font-size:16px;line-height:18px}.FormMetricModal-module__dsAction--pjtLW,.FormMetricModal-module__dsAction--pjtLW *{font-size:14px;line-height:16px}.FormMetricModal-module__dsActionSmall--hxDf6,.FormMetricModal-module__dsActionSmall--hxDf6 *{font-size:12px;line-height:14px}.FormMetricModal-module__dsColumnHeadLine--Ozzkv,.FormMetricModal-module__dsColumnHeadLine--Ozzkv *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.FormMetricModal-module__dsLightXL--w0dms,.FormMetricModal-module__dsLightXL--w0dms *{font-size:120px;line-height:160px;font-weight:300}.FormMetricModal-module__dsLightLarge--bprKR,.FormMetricModal-module__dsLightLarge--bprKR *{font-size:48px;line-height:64px;font-weight:300}.FormMetricModal-module__dsLight--hSU20,.FormMetricModal-module__dsLight--hSU20 *{font-size:32px;line-height:64px;font-weight:300}.FormMetricModal-module__dsLightSmall--jitK7,.FormMetricModal-module__dsLightSmall--jitK7 *{font-size:24px;line-height:36px;font-weight:300}.FormMetricModal-module__dsLightXS--UZNwc,.FormMetricModal-module__dsLightXS--UZNwc *{font-size:18px;line-height:27px;font-weight:300}.FormMetricModal-module__formContainer--nHim8{display:flex;flex-direction:column;gap:32px;width:424px}.FormMetricModal-module__fieldGroup--OPGiY{display:flex;gap:16px}.FormMetricModal-module__field--K7Nv5{display:flex;flex-direction:column;gap:10px}.FormMetricModal-module__field--K7Nv5 input[type=datetime-local]::-webkit-calendar-picker-indicator{background-image:url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" color="%238C95A8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.41669 9.66663C4.41669 9.29844 4.71516 8.99996 5.08335 8.99996H10.5C10.8682 8.99996 11.1667 9.29844 11.1667 9.66663C11.1667 10.0348 10.8682 10.3333 10.5 10.3333H5.08335C4.71516 10.3333 4.41669 10.0348 4.41669 9.66663Z" fill="currentColor"/><path d="M5.08335 11.5C4.71516 11.5 4.41669 11.7984 4.41669 12.1666C4.41669 12.5348 4.71516 12.8333 5.08335 12.8333H10.5C10.8682 12.8333 11.1667 12.5348 11.1667 12.1666C11.1667 11.7984 10.8682 11.5 10.5 11.5H5.08335Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.99937 1.33329C5.99937 0.965103 5.70089 0.666626 5.3327 0.666626C4.96451 0.666626 4.66604 0.965103 4.66604 1.33329V1.99988H4.00002C2.15907 1.99988 0.666687 3.49226 0.666687 5.33321V11.9999C0.666687 13.8408 2.15907 15.3332 4.00002 15.3332H12C13.841 15.3332 15.3334 13.8408 15.3334 11.9999V5.33321C15.3334 3.49226 13.841 1.99988 12 1.99988H11.3337V1.33329C11.3337 0.965103 11.0352 0.666626 10.667 0.666626C10.2988 0.666626 10.0003 0.965103 10.0003 1.33329V1.99988H5.99937V1.33329ZM14 6V5.33321C14 4.22864 13.1046 3.33321 12 3.33321H11.3337V3.99996C11.3337 4.36815 11.0352 4.66663 10.667 4.66663C10.2988 4.66663 10.0003 4.36815 10.0003 3.99996V3.33321H5.99937V3.99996C5.99937 4.36815 5.70089 4.66663 5.3327 4.66663C4.96451 4.66663 4.66604 4.36815 4.66604 3.99996V3.33321H4.00002C2.89545 3.33321 2.00002 4.22864 2.00002 5.33321V6H14ZM2.00002 7.33333H14V11.9999C14 13.1044 13.1046 13.9999 12 13.9999H4.00002C2.89545 13.9999 2.00002 13.1044 2.00002 11.9999V7.33333Z" fill="currentColor"/></svg>')}.FormMetricModal-module__fieldLabel--vEPIi b{color:#f14668;padding-left:4px}.FormMetricModal-module__errorText--CQQQY{font-size:12px;color:#f14668}.FormMetricModal-module__infoIconContainer--w2zBj{padding-left:4px;padding-right:4px}.FormMetricModal-module__infoIconContainer--w2zBj svg{color:#8c95a8;margin-bottom:-4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `FormMetricModal-module__dsAccented--ibQyD`,
	"dsDefaultWeight": `FormMetricModal-module__dsDefaultWeight--SGAxN`,
	"dsUnderline": `FormMetricModal-module__dsUnderline--U0jHe`,
	"dsAccented2": `FormMetricModal-module__dsAccented2--rTOei`,
	"dsBodyXL": `FormMetricModal-module__dsBodyXL--jofJk`,
	"dsBodyLarge": `FormMetricModal-module__dsBodyLarge--r3ZzZ`,
	"dsBody": `FormMetricModal-module__dsBody--dK2TO`,
	"dsBodySmall": `FormMetricModal-module__dsBodySmall--z9OVT`,
	"dsBodyXS": `FormMetricModal-module__dsBodyXS--LrzZn`,
	"dsActionLarge": `FormMetricModal-module__dsActionLarge--rBj4A`,
	"dsAction": `FormMetricModal-module__dsAction--pjtLW`,
	"dsActionSmall": `FormMetricModal-module__dsActionSmall--hxDf6`,
	"dsColumnHeadLine": `FormMetricModal-module__dsColumnHeadLine--Ozzkv`,
	"dsLightXL": `FormMetricModal-module__dsLightXL--w0dms`,
	"dsLightLarge": `FormMetricModal-module__dsLightLarge--bprKR`,
	"dsLight": `FormMetricModal-module__dsLight--hSU20`,
	"dsLightSmall": `FormMetricModal-module__dsLightSmall--jitK7`,
	"dsLightXS": `FormMetricModal-module__dsLightXS--UZNwc`,
	"formContainer": `FormMetricModal-module__formContainer--nHim8`,
	"fieldGroup": `FormMetricModal-module__fieldGroup--OPGiY`,
	"field": `FormMetricModal-module__field--K7Nv5`,
	"fieldLabel": `FormMetricModal-module__fieldLabel--vEPIi`,
	"errorText": `FormMetricModal-module__errorText--CQQQY`,
	"infoIconContainer": `FormMetricModal-module__infoIconContainer--w2zBj`
};
module.exports = ___CSS_LOADER_EXPORT___;
